import { connect } from 'react-redux'


import DeleteIndividualMapping from './components'

export default connect()(
  DeleteIndividualMapping,
)
